import React, { ChangeEvent, useState } from "react";
import "./form-login.scss";
import { BsEye, BsEyeSlash } from "react-icons/bs";
import { useFormContext, Controller } from "react-hook-form";
import { ErrorMessage } from "@hookform/error-message";
import { DatePicker, Input } from "antd";
import type { Dayjs } from "dayjs";
import type { DatePickerProps } from "antd";
const onChangeDate: DatePickerProps<Dayjs[]>["onChange"] = (
  date,
  dateString
) => {
  console.log(date, dateString);
};
interface LoginInputProps {
  name: string;
  style: object; // width and height
  type: string;
  label: string;
  placeholder: string;
  disable?: boolean;
  visiblePassword?: any;
  setVisiblePassword?: any;
  isPassword?: boolean;
  rules: any;
}

const LoginInput: React.FC<LoginInputProps> = ({
  name,
  style,
  type,
  label,
  placeholder,
  isPassword,
  disable,
  visiblePassword,
  setVisiblePassword,
  rules,
}) => {
  const {
    control,
    formState: { errors },
    trigger,
  } = useFormContext();
  return (
    <div className="input-field-container" style={{ position: "relative" }}>
      <Controller
        name={name}
        control={control}
        rules={rules}
        defaultValue={""}
        render={({ field }) => (
          <div>
            {type !== "date" && (
              <div>
                <Input
                  className="custom-input"
                  placeholder={placeholder}
                  style={style}
                  value={field.value || ""}
                  onChange={field.onChange}
                  onBlur={() => {
                    trigger(field.name);
                  }}
                  type={isPassword && visiblePassword ? " " : type}
                />
                {type === "password" && (
                  <button
                    className="password-toggle-btn"
                    onClick={(e: any) => {
                      e.preventDefault();
                      setVisiblePassword((prev: boolean) => !prev);
                    }}
                  >
                    {visiblePassword === false ? <BsEyeSlash /> : <BsEye />}
                  </button>
                )}
              </div>
            )}
            {type === "date" && (
              <DatePicker
                className="datepicker-input"
                style={style}
                placeholder={placeholder}
                onChange={(date) => field.onChange(date)}
                onBlur={() => {
                  trigger(field.name);
                }}
                needConfirm
              />
            )}

            <ErrorMessage
              errors={errors}
              name={name}
              render={({ message }) => (
                <p
                  style={{
                    color: "red",
                    marginBottom: 20,
                    position: "absolute",
                    top: "100%" /* Hiển thị thông báo lỗi ngay dưới trường input */,
                    left: 0,
                  }}
                >
                  {message}
                </p>
              )}
            />
          </div>
        )}
      />
    </div>
  );
};

export default LoginInput;
